export default "__VITE_ASSET__567b99a1__"